/**
 * Hero 2022
 * Custom element: https://nokiantyres.stage.crasman.fi/admin/manage/scriptlets/scriptletmanager/scriptleteditor/custom/code/show/eut3-iSHQPaGQE7w6BtVnA
 */

const elements = document.getElementsByClassName('js-hero-2022');
if(elements.length) {
  import('./hero').then(({init}) => {
    for(let collection of elements) {
      init(collection);
    }
  });
}
